import UploadController from '@mm/state/controllers/UploadController';
import { activeCompanySelector } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { UploadImgModel } from '@mm/state/model/UploadImgModel';
import ImageUpload from '../../../../../common/components/ImageUpload/ImageUpload';
import './TemplateUploadFile.scss';

type Props = {
  initalImage?: string;
  name: string;
  onChange: (e: { target: { name: string; value: number } }) => any;
} & ReturnType<typeof mapStateToProps>;

const TemplateUploadFilePure = ({
  initalImage,
  name,
  company,
  onChange,
}: Props) => {
  const [currentImage, setCurrentImage] = useState(
    initalImage as string | undefined,
  );

  useEffect(() => {
    setCurrentImage(initalImage);
  }, [initalImage]);

  const onUpload = async (img64: UploadImgModel) => {
    if (company) {
      const resp = await UploadController.uploadImage(img64, company.id);
      setCurrentImage(resp.urls.medium);
      onChange({ target: { name, value: resp.id } });
      return resp;
    }
  };

  return (
    <ImageUpload
      className="template-upload-file"
      imgUrl={currentImage || ''}
      hideCropIcon
      uploadImage={onUpload}
      removeImage={() => {}}
      onRatioChange={() => {}}
    />
  );
};

const mapStateToProps = (state: StoreState) => ({
  company: activeCompanySelector(state),
});

export const TemplateUploadFile = connect(mapStateToProps)(
  TemplateUploadFilePure,
);
